import classNames from 'classnames'
import React, { Component } from 'react'

import CvcHelpButton from '~/components/cvc-help-button'
import Icon from '~/components/icon'
import SelectInput from '~/components/select-input'
import TextInput from '~/components/text-input'
import { i18n } from '~/i18n'
import { iconGlyphForCreditCardType, CARD_TYPES_USD } from '~/utils/credit-card'
import { CARD_MONTHS, CARD_YEARS } from '~/utils/date'

import './credit-card-form.scss'
import { Form } from './styles'

import type { ComponentType } from 'react'
import type { Props as SelectInputProps } from '~/components/select-input'
import type { Props as TextInputProps } from '~/components/text-input'
import type { CreditCardType, NewCreditCard } from '~/types'

export type Props = {
  creditCard: NewCreditCard
  creditCardTypes: CreditCardType[]
  errors: Record<string, any>
  onChange: (arg0: string, arg1: string) => void
  className?: string
  TextInputComponent: ComponentType<TextInputProps>
  SelectInputComponent: ComponentType<SelectInputProps>
}

export default class CreditCardForm extends Component<Props> {
  static defaultProps = {
    creditCardTypes: CARD_TYPES_USD,
    TextInputComponent: TextInput,
    SelectInputComponent: SelectInput,
  }

  constructor(props: Props) {
    super(props)
  }

  renderCardType(cardType: string | null | undefined) {
    return (
      <Icon
        key={cardType}
        className="card-type"
        glyph={iconGlyphForCreditCardType(cardType || '')}
        alt={cardType}
      />
    )
  }

  getCreditCardFields() {
    return {
      nameOnCard: {
        type: 'text' as const,
        label: i18n.t('components.credit_card_form.name_label'),
        id: 'card-name',
        name: 'card-name',
        placeholder: i18n.t('components.credit_card_form.name_placeholder'),
      },
      number: {
        type: 'text' as const,
        label: i18n.t('components.credit_card_form.number_label'),
        id: 'card-number',
        name: 'card-number',
        placeholder: i18n.t('components.credit_card_form.number_placeholder'),
        decorations: (
          <div className="logos">
            {this.props.creditCardTypes.map(this.renderCardType)}
          </div>
        ),
      },
      month: {
        type: 'select' as const,
        label: i18n.t('components.credit_card_form.expiration_label'),
        options: CARD_MONTHS,
        placeholder: i18n.t('components.credit_card_form.month_placeholder'),
        id: 'card-month',
        name: 'card-month',
      },
      year: {
        type: 'select' as const,
        label: <span>&nbsp;</span>,
        options: CARD_YEARS,
        placeholder: i18n.t('components.credit_card_form.year_placeholder'),
        id: 'card-year',
        name: 'card-year',
      },
      cvc: {
        type: 'text' as const,
        id: 'card-cvc',
        name: 'card-cvc',
        label: i18n.t('components.credit_card_form.cvc_label'),
        placeholder: i18n.t('components.credit_card_form.cvc_placeholder'),
        sublabel: <CvcHelpButton />,
        fieldClass: 'card-cvc',
        maxLength: 4,
      },
    }
  }

  render() {
    const {
      creditCard,
      onChange,
      errors,
      TextInputComponent,
      SelectInputComponent,
      className,
    } = this.props

    return (
      <Form
        className={classNames('amp-credit-card-form', className)}
        object={creditCard}
        errors={errors}
        fields={this.getCreditCardFields()}
        onChange={(field, value) => {
          if (typeof value === 'string') {
            onChange(field, value)
          }
        }}
        TextInputComponent={TextInputComponent}
        SelectInputComponent={SelectInputComponent}
      />
    )
  }
}
